import type { UserListEntry } from "../../api/types";
import type { TeamViewer } from "../../utils/teamMemberPermissions";
import { teamMemberPermissions } from "../../utils/teamMemberPermissions";
import { EmptyState } from "../ui/EmptyState";
import { TeamMemberCard } from "./TeamMemberCard";

/**
 * G-145 — the team as a grid of tiles at every width (G-102 began it as the
 * phone-only list beside a 13-column desktop table, now gone). The filter
 * chips sit above this, in the page.
 */
export function TeamCardList({
  users,
  viewer,
  loading,
  filtered,
  onOpen,
}: {
  users: UserListEntry[];
  viewer: TeamViewer;
  loading: boolean;
  /** True when a chip or the inactive toggle is hiding somebody. */
  filtered: boolean;
  onOpen: (user: UserListEntry) => void;
}) {
  // Only the first load blanks the grid: a refresh after an action keeps the
  // tiles (and the open panel above them) in place while the list reloads.
  if (loading && users.length === 0) {
    return <p className="muted team-tiles-empty">Loading…</p>;
  }

  if (users.length === 0) {
    // "Nobody matches this filter" and "there is no team yet" are different
    // facts, and the second one must not be told when the first is true.
    return filtered ? (
      <EmptyState
        title="Nobody matches this filter"
        message="Try another role, or show deactivated people."
      />
    ) : (
      <EmptyState title="No users yet" />
    );
  }

  return (
    <div className="team-tiles">
      {users.map((user) => (
        <TeamMemberCard
          key={user.id}
          user={user}
          permissions={teamMemberPermissions(user, viewer)}
          onOpen={onOpen}
        />
      ))}
    </div>
  );
}
